import React, {useEffect, useState} from 'react';
import DropdownTreeSelect from "react-dropdown-tree-select";
import {Controller} from "react-hook-form";
import "../../assets/css/pages/tree-select.css";

const flatten = arr => {
  let result = [];
  arr.forEach(function (item) {
    result.push(item);
    if (Array.isArray(item.children)) {
      result = result.concat(flatten(item.children));
    }
  });
  return result;
}

const findAllAncestors = (flattenedOptions, id, res) => {
  let parent = flattenedOptions.find(option => option.value == id)
  if(parent){
    res.push(parent.value)
    if (parent.parent_id){
      findAllAncestors(flattenedOptions, parent.parent_id, res)
    }
  }
  return res;
}

const assignObjectPaths = (obj, stack, selectedValue, ancestors) => {
  if (obj?.value && ancestors.includes(obj?.value)){
    obj.expanded = true;
  }else delete obj.expanded;

  Object.keys(obj).forEach(key => {
    const node = obj[key];
    if (typeof node === "object") {
      if (node.value == selectedValue) {
        node.checked = true;
      } else {
        delete node.checked;
      }
      node.path = stack ? `${stack}.${key}` : key;
      assignObjectPaths(node, node.path, selectedValue, ancestors);
    }
  });
};


export default function ({
                           label,
                           name,
                           control,
                           errorMessage,
                           options = [],
                           placeholder = 'აირჩიეთ',
                           className = '',
                           parentClasses = '',
                           inputClassName = '',
                           value,
                           callback = null,
                           required = false,
                           setValue,
                           disabled=false
                         }) {

  const handleChange = (selected, onChange) => {
    const val = selected?.checked ? selected?.value : null;
    let ancestors = [];
    if(val){
      ancestors = findAllAncestors(flatten(options), val, [])
    }
    onChange(val);
    assignObjectPaths(options, null, parseInt(val), ancestors);
    if (callback) callback(val);
  }

  useEffect(() => {
    if (value) {
      setValue(name, value)
      let ancestors =  findAllAncestors(flatten(options), value, [])
      assignObjectPaths(options, null, parseInt(value), ancestors);
    }
  }, [value])

  return (

    <>
      <div>
        <Controller
          name={name}
          control={control}
          render={({field: {onChange}}) => (
            <div className={`fv-row mb-10${parentClasses ? " " + parentClasses : ''}`}>
              <label className="form-label fs-6 fw-bolder color-dark-grey">
                {label}{required && (<span className="text-danger fw-bolder fs-6"> *</span>)}
              </label>
              <DropdownTreeSelect
                data={options}
                onChange={(selected) => handleChange(selected, onChange)}
                mode="radioSelect"
                disabled={disabled}
              />

              {errorMessage && (
                <div className="fv-plugins-message-container invalid-feedback">
                  <div>{errorMessage}</div>
                </div>
              )}
            </div>
          )}
        />
      </div>
    </>
  )
}